import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.LIST_SET_FILTERS](state, { providerId, levyCollectionId }) {
    state.listing.providerId = providerId;
    state.listing.levyCollectionId = levyCollectionId;
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, records) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = records;
  },

  [mutation.EDIT_SET_DATA](state, details) {
    stateMerge(state.edit.data, details);
    state.edit.error.show = false;
  },
  [mutation.EDIT_CLEAR](state) {
    state.edit.loading = false;
    state.edit.isNew = true;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_STARTED](state) {
    state.edit.data = getBlankRecord();
    state.edit.loading = true;
    state.edit.isNew = false;
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },
  [mutation.EDIT_GET_SUCCEEDED](state, provider) {
    state.edit.loading = false;
    stateMerge(state.edit.data, provider);
  },
  [mutation.EDIT_SAVE_STARTED](state) {
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state) {
    state.edit.saving = false;
  },
  [mutation.EDIT_DELETE_STARTED](state) {
    state.delete.processing = true;
  },
  [mutation.EDIT_DELETE_FAILED](state) {
    state.delete.processing = false;
  },
  [mutation.EDIT_DELETE_SUCCEEDED](state) {
    state.delete.processing = false;
  },

  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  }
};
